var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 19.2",
    style: {
      enableBackground: "new 0 0 17 19.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_12_settings",
    transform: "translate(-25.000000, -341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3",
    transform: "translate(0.000000, 322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(25.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.200700)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fill: "#698DB0",
    d: "M14.5,5.5c1.6,1.6,2.5,3.7,2.5,6s-0.9,4.4-2.5,6c-1.6,1.6-3.7,2.5-6,2.5 c-2.3,0-4.4-0.9-6-2.5c-3.3-3.3-3.3-8.7,0-12c0.1-0.1,0.3-0.2,0.4-0.2s0.3,0.1,0.4,0.2c0.2,0.2,0.2,0.6,0,0.9 C2,7.8,1.3,9.6,1.3,11.5c0,1.9,0.7,3.7,2.1,5.1c1.4,1.4,3.2,2.1,5.1,2.1c1.9,0,3.7-0.7,5.1-2.1c1.4-1.4,2.1-3.2,2.1-5.1 s-0.8-3.7-2.1-5.1c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.2,0.1-0.3,0.2-0.4C13.8,5.3,14.2,5.3,14.5,5.5z M8.5,10.1 c-0.3,0-0.6-0.3-0.6-0.6v-8c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v8C9.1,9.8,8.8,10.1,8.5,10.1z"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.b2b42b8b.svg";
export { ForwardRef as ReactComponent };